import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import LoaderProjectCard from '../../project/project-flat-card/LoaderProjectCard';
import { formatMoneyKr } from '../../utils';
import { SectionTitle } from '../../components/typography/Heading';
import { OrganizationTemplateCard } from '../../organization/organization-show/organization-cta-card/OrganizationTemplateCard';
import styles from './top-three-template-causes.module.less';

const fetchTopTemplateCausesLastMonth = async ({ baseUrl }) => {
    const fullUrl = `${baseUrl}/api/public/template/top-three-template-causes`;
    return fetch(fullUrl);
};

const TopThreeTemplateCauses = () => {
    const baseUrl = useSelector((state) => state.baseURL);
    const [causes, setCauses] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const asyncFetch = async () => {
            try {
                const response = await fetchTopTemplateCausesLastMonth({ baseUrl });
                if (response.status === 200) {
                    const templateCausesResponse = await response.json();
                    setCauses(templateCausesResponse);
                    setLoading(false);
                } else {
                    setLoading(false);
                }
            } catch (e) {
                setLoading(false);
            }
        };
        asyncFetch();
    }, [baseUrl]);

    if (!loading && (!causes || causes.length === 0)) {
        return null;
    }

    if (loading) {
        return (
            <section className={styles.campaignsContainer}>
                <SectionTitle tag="h2" className={styles.subTitle}>
                    Topp 3 aksjoner siste måned
                </SectionTitle>
                <ul className={styles.listContainer}>
                    <li key={1}>
                        <LoaderProjectCard />
                    </li>
                    <li key={2}>
                        <LoaderProjectCard />
                    </li>
                    <li key={3}>
                        <LoaderProjectCard />
                    </li>
                </ul>
            </section>
        );
    }

    return (
        <section className={styles.campaignsContainer}>
            <SectionTitle tag="h2" className={styles.subTitle}>
                Topp 3 aksjoner siste måned
            </SectionTitle>
            <ol className={styles.listContainer}>
                {causes.map((cause) => (
                    <li key={cause.id}>
                        <OrganizationTemplateCard
                            causeId={cause.id}
                            templateId={cause.template_id}
                            title={cause.title}
                            description={cause.description}
                            img_url={cause.img_url}
                            dugnad={cause.dugnad}
                            birthday={cause.birthday}
                            params={cause.params}
                            customLink={cause.profile?.customLink}
                            customLinkText={cause.profile?.customLinkText}
                            startProjectText={cause.profile?.startProjectText}
                            redirectToPreview={cause.profile?.redirectToPreview}
                            schoolId={cause.schoolId}
                            causeType={cause.type}
                        />
                    </li>
                ))}
            </ol>
        </section>
    );
};

export default TopThreeTemplateCauses;
